import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0282184a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = ["href"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Booza logo",
  src: "/images/logo.png",
  class: "logo"
}, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = ["href"]
const _hoisted_6 = { class: "game-mode-container" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_maintenance_mode = _resolveComponent("maintenance-mode")!
  const _component_login = _resolveComponent("login")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_single_room_modal = _resolveComponent("single-room-modal")!
  const _component_donate_modal = _resolveComponent("donate-modal")!
  const _component_settings_modal = _resolveComponent("settings-modal")!
  const _component_help_modal = _resolveComponent("help-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", { href: _ctx.homePage }, _hoisted_4, 8, _hoisted_2),
    (_ctx.progress < 100)
      ? (_openBlock(), _createBlock(_component_loader, {
          key: 0,
          progress: _ctx.progress,
          class: "loading"
        }, null, 8, ["progress"]))
      : (_ctx.isLoginShown)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.isMaintenanceMode)
              ? (_openBlock(), _createBlock(_component_maintenance_mode, { key: 0 }))
              : (_openBlock(), _createBlock(_component_login, { key: 1 }))
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("a", { href: _ctx.homePage }, [
              _createVNode(_component_fa_icon, {
                icon: "home",
                color: "white",
                size: "2x",
                class: "icon home"
              })
            ], 8, _hoisted_5),
            _createVNode(_component_fa_icon, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isDonateShown = true)),
              icon: "heart",
              color: "white",
              size: "2x",
              class: "icon donate"
            }),
            _createVNode(_component_fa_icon, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isHelpShown = true)),
              icon: "question",
              color: "white",
              size: "2x",
              class: "icon help"
            }),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameModes, (game) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: game.id,
                  class: "game-button",
                  onClick: ($event: any) => (_ctx.onSelectGame(game))
                }, [
                  (game.image)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: game.image,
                        alt: "Ball image",
                        class: "ball"
                      }, null, 8, _hoisted_8))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", {
                    innerHTML: game.label
                  }, null, 8, _hoisted_9)
                ], 8, _hoisted_7))
              }), 128))
            ]),
            ((_ctx.isRoomsShown && _ctx.roomsCount === 1) || _ctx.isGameSelected)
              ? (_openBlock(), _createBlock(_component_single_room_modal, {
                  key: 0,
                  onClose: _ctx.closeRoomsModal
                }, null, 8, ["onClose"]))
              : _createCommentVNode("", true),
            (_ctx.isDonateShown)
              ? (_openBlock(), _createBlock(_component_donate_modal, {
                  key: 1,
                  onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isDonateShown = false))
                }))
              : _createCommentVNode("", true),
            (_ctx.isSettingsShown)
              ? (_openBlock(), _createBlock(_component_settings_modal, {
                  key: 2,
                  onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isSettingsShown = false))
                }))
              : _createCommentVNode("", true),
            (_ctx.isHelpShown)
              ? (_openBlock(), _createBlock(_component_help_modal, {
                  key: 3,
                  onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isHelpShown = false))
                }))
              : _createCommentVNode("", true)
          ], 64))
  ]))
}